module.exports = __webpack_public_path__ + "control.P_BJMXtR.svg";